<template>
    <div class="body fixed mobile" v-show="open">
        <section
            class="popNoQA popup"
            ref="popup"
        >
            <div class="popBody">
                <a class="close" @click.prevent="close('close')">
                    <font-awesome-icon icon="fas fa-times"></font-awesome-icon>
                </a>
                <section class="popHeader">
                    <div class="img">
                        <img src="@/assets/icon/question-w.svg" />
                    </div>
                </section>
                <section class="popMain">
                    <span class="fL">{{title}}</span>
                    <span class="fM gray">{{message}}</span>
                </section>
                <section class="popFooter" v-if="footer">
                    <a class="button rounded white" @click.prevent="close('btn-left')">
                        <span class="fM">{{buttonLeft}}</span>
                    </a>
                    <a class="button rounded" @click.prevent="close('btn-right')">
                        <span class="fM">{{buttonRight}}</span>
                    </a>
                </section>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Popup",
    props: {
        open: {
            type: Boolean,
            default: false
        },
        footer: {
            type: Boolean,
            default: false
        },
        buttonLeft: {
            type: String,
            default: "前往點數頁"
        },
        buttonRight: {
            type: String,
            default: "回首頁"
        },
        title: String,
        message: String
    },
    data() {
        return {
        };
    },
    mounted() {
        // this.$el.addEventListener('click', this.onClick)
        this.popup();
    },
    methods: {
        close(eventName) {
            this.$emit(eventName);
        },
        popup() {
            let target = this.$refs['popup'];
            target.style.display = "flex";
        },
        // onClick() {
        //     this.close('close');
        // }
    }
};
</script>

<style src="@/assets/css/app.css"></style>
<style src="@/assets/css/unique.css"></style>
